import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import BottomNav from './components/BottomNav';
import MusicPlayer from './components/MusicPlayer';
import Home from './pages/Home';
import Search from './pages/Search';
import Library from './pages/Library';
import AlbumDetail from './pages/AlbumDetail';
import PlaylistDetail from './pages/PlaylistDetail';
import Auth from './pages/Auth';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import CreatePlaylist from './pages/CreatePlaylist';
import LikedSongs from './pages/LikedSongs';
import Albums from './pages/Albums';
import { mockSongs } from './data/mockData';
import { Toaster } from './components/ui/sonner';

function App() {
  const [currentSong, setCurrentSong] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [queue, setQueue] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePlaySong = (song, songList = null) => {
    setCurrentSong(song);
    setIsPlaying(true);
    if (songList) {
      setQueue(songList);
      setCurrentIndex(songList.findIndex(s => s.id === song.id));
    }
  };

  const handleNext = () => {
    if (queue.length > 0 && currentIndex < queue.length - 1) {
      const nextIndex = currentIndex + 1;
      setCurrentIndex(nextIndex);
      setCurrentSong(queue[nextIndex]);
    }
  };

  const handlePrevious = () => {
    if (queue.length > 0 && currentIndex > 0) {
      const prevIndex = currentIndex - 1;
      setCurrentIndex(prevIndex);
      setCurrentSong(queue[prevIndex]);
    }
  };

  return (
    <div className="App h-screen flex overflow-hidden bg-gray-50">
      <BrowserRouter>
        <Sidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Routes>
            <Route path="/" element={<><TopBar /><Home onPlaySong={handlePlaySong} /></>} />
            <Route path="/search" element={<><TopBar /><Search onPlaySong={handlePlaySong} /></>} />
            <Route path="/library" element={<><TopBar /><Library onPlaySong={handlePlaySong} /></>} />
            <Route path="/album/:id" element={<><TopBar /><AlbumDetail onPlaySong={handlePlaySong} /></>} />
            <Route path="/playlist/:id" element={<><TopBar /><PlaylistDetail onPlaySong={handlePlaySong} /></>} />
            <Route path="/create-playlist" element={<><TopBar /><CreatePlaylist /></>} />
            <Route path="/liked" element={<><TopBar /><LikedSongs onPlaySong={handlePlaySong} /></>} />
            <Route path="/albums" element={<><TopBar /><Albums onPlaySong={handlePlaySong} /></>} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/profile" element={<><TopBar /><Profile /></>} />
            <Route path="/admin" element={<><TopBar /><AdminPanel /></>} />
          </Routes>
        </div>
        <BottomNav />
        <MusicPlayer
          currentSong={currentSong}
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          onNext={handleNext}
          onPrevious={handlePrevious}
        />
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
